<breadcrumb></breadcrumb>
<div class="content-box" [class.loading-overlay-active]="isLoadingInformation">
  <div class="loading-overlay" *ngIf="isLoadingInformation">
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="element-wrapper">
        <h6 class="element-header">
          WhatsApp Bot Einstellungen
        </h6>
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <mat-card class="status-card">
                  <div class="header">
                    <mat-card-title>Verbindungsstatus</mat-card-title>

                    <div class="status-indicator">
                      <span class="dot" [class.connected]="isConnected" [class.disconnected]="!isConnected"></span>

                      <span class="label" [class.connected]="isConnected" [class.disconnected]="!isConnected">
                        {{ isConnected ? 'Verbunden' : 'Getrennt' }}
                      </span>
                    </div>
                  </div>

                  <mat-card-content [formGroup]="botStatusForm">
                    <div class="bot-status">
                      <div class="left">
                        <mat-icon [color]="isConnected ? 'primary' : 'warn'">
                          {{ isConnected ? 'wifi' : 'wifi_off' }}
                        </mat-icon>
                        <span>Whatsapp Bot aktiv</span>
                      </div>

                      <mat-slide-toggle
                        formControlName="enabled"
                        [disabled]="!isClientFound"
                        (change)="onBotStatusToggle()"
                      ></mat-slide-toggle>
                    </div>

                    <button mat-stroked-button color="primary" class="connect-btn" (click)="handleConnect()">
                      <mat-icon class="material-icons-round">repeat</mat-icon>
                      {{ isConnected ? 'Neu verbinden' : 'Verbinden' }}
                      <mat-icon class="external">open_in_new</mat-icon>
                    </button>

                    <div *ngIf="phoneNumberInfo" class="phone-info-section">
                      <div class="phone-info-divider"></div>
                      <div class="phone-info-header">
                        <mat-icon>info</mat-icon>
                        <span>Meta Telefonnummer Informationen</span>
                      </div>
                      <div class="phone-info-item" *ngIf="phoneNumberInfo.verifiedName">
                        <div class="phone-info-label">
                          <mat-icon>verified_user</mat-icon>
                          Verifizierter Name
                        </div>
                        <div class="phone-info-value">{{ phoneNumberInfo.verifiedName }}</div>
                      </div>
                      <div class="phone-info-item" *ngIf="phoneNumberInfo.displayPhoneNumber">
                        <div class="phone-info-label">
                          <mat-icon>phone</mat-icon>
                          Telefonnummer
                        </div>
                        <div class="phone-info-value">{{ phoneNumberInfo.displayPhoneNumber }}</div>
                      </div>
                      <div class="phone-info-item" *ngIf="phoneNumberInfo.codeVerificationStatus">
                        <div class="phone-info-label">
                          <mat-icon>check_circle</mat-icon>
                          Verifizierungsstatus
                        </div>
                        <div class="phone-info-value">{{ phoneNumberInfo.codeVerificationStatus }}</div>
                      </div>
                    </div>

                    <!-- 
                    <div *ngIf="whatsappId" class="whatsapp-id">
                      <small>WhatsApp Business ID</small>
                      <code>{{ whatsappId }}</code>
                    </div> -->
                  </mat-card-content>
                </mat-card>
              </div>
              <div>
                <mat-card class="features-card" [formGroup]="featureForm">
                  <mat-card-title>Bot Funktionen</mat-card-title>

                  <div formArrayName="features">
                    <div
                      *ngFor="let ctrl of featuresArray.controls; let i = index"
                      [formGroupName]="i"
                      class="feature-item mb-3"
                    >
                      <div class="left">
                        <div class="icon-wrapper" [class.enabled]="ctrl.get('enabled').value">
                          <mat-icon>
                            {{ getIcon(getFeatureMeta(ctrl.value.featureKey)?.icon || '') }}
                          </mat-icon>
                        </div>

                        <div class="text">
                          <div class="name">
                            {{ getFeatureMeta(ctrl.value.featureKey)?.name || ctrl.value.featureKey }}
                          </div>
                          <div class="description">
                            {{ getFeatureMeta(ctrl.value.featureKey)?.description || '' }}
                          </div>
                        </div>
                      </div>

                      <mat-slide-toggle
                        formControlName="enabled"
                        [disabled]="!isClientFound"
                        (change)="onFeatureToggle(ctrl.value, i)"
                      >
                      </mat-slide-toggle>
                    </div>
                  </div>
                </mat-card>
              </div>
            </div>
            <div class="col-md-6">
              <mat-card class="information-card" [formGroup]="informationForm">
                <div class="header">
                  <mat-card-title>Informationen</mat-card-title>

                  <button
                    mat-raised-button
                    color="primary"
                    (click)="saveInformation()"
                    [disabled]="isSaving || !isClientFound"
                    class="btn btn-primary save-btn"
                  >
                    <mat-icon>save</mat-icon>
                    <span class="label">
                      {{ isSaving ? 'Speichern...' : 'Speichern' }}
                    </span>
                  </button>
                </div>

                <div class="content">
                  <div class="field">
                    <label class="field-label">
                      <mat-icon>playlist_add_check</mat-icon>
                      Zusätzliche Informationen
                    </label>

                    <mat-form-field appearance="outline" class="full-width">
                      <textarea
                        matInput
                        rows="5"
                        placeholder="Zusätzliche Informationen für den Bot eingeben…"
                        formControlName="restaurantContext"
                      >
                      </textarea>
                    </mat-form-field>

                    <p class="hint">
                      Füttern Sie den Bot mit zusätzlichen Informationen wie Parkplätze oder anderen Informationen, nach
                      denen Gäste fragen könnten.
                    </p>
                  </div>

                  <div class="field">
                    <label class="field-label">
                      <mat-icon>star_half</mat-icon>
                      Informationen für die KI
                    </label>

                    <mat-form-field appearance="outline" class="full-width">
                      <textarea
                        matInput
                        rows="5"
                        placeholder="Anweisungen für die KI eingeben…"
                        formControlName="botInstructions"
                      ></textarea>
                    </mat-form-field>

                    <p class="hint">
                      Hier können Sie festlegen, wie der Bot antwortet oder ihm zusätzliche Anweisungen geben. Beispiel:
                      "Antworte immer auf schwäbisch"
                    </p>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="row" *ngIf="isConnected">
            <div class="col-12">
              <mat-card class="templates-card mt-3">
                <div class="header">
                  <mat-card-title>Vorlagen</mat-card-title>
                </div>
                <mat-card-content>
                  <p class="templates-subtitle">
                    Diese Vorlagen werden verwendet, um Nachrichten an Benutzer zu senden (nicht als Antworten auf deren
                    Nachrichten), wie z.B. Reservierungserinnerungen oder Restaurant-News.
                  </p>
                  <div *ngIf="isLoadingTemplates" class="loading-state">
                    <mat-icon>hourglass_empty</mat-icon>
                    <span>Vorlagen werden geladen...</span>
                  </div>
                  <div *ngIf="!isLoadingTemplates && templates.length === 0" class="empty-state">
                    <mat-icon>description</mat-icon>
                    <span>Keine Vorlagen gefunden</span>
                  </div>
                  <div *ngIf="!isLoadingTemplates && templates.length > 0" class="templates-list">
                    <div *ngFor="let template of templates" class="template-item">
                      <div class="template-info">
                        <div class="template-header">
                          <span class="template-name">{{ getTemplateName(template) }}</span>
                          <span class="badge" [ngClass]="'badge-' + getStatusBadgeClass(template.status)">
                            {{ template.status | uppercase }}
                          </span>
                          <span class="template-language">
                            <mat-icon>language</mat-icon>
                            {{ getTemplateLanguage(template) }}
                          </span>
                        </div>
                        <div class="template-description" *ngIf="hasTemplateDescription(template)">
                          {{ getTemplateDescription(template) }}
                        </div>
                      </div>
                      <div class="template-actions">
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="openEditTemplateModal(template)"
                          [disabled]="!hasTemplateType(template)"
                        >
                          <mat-icon>edit</mat-icon>
                          Vorlage bearbeiten
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
